import React from 'react';

import { Stack } from '@mui/material';

import PageNotFoundImage from './../../Assets/Images/PageNotFound.svg';

function PageNotFound() {
  return (
    <Stack alignItems='center' justifyContent='center'>
      <img
        src={PageNotFoundImage}
        alt='Page Not Found'
        style={{ height: '100vh', width: '100vw', objectFit: 'contain' }}
        width={200}
        height={100}
      />
    </Stack>
  );
}

export default PageNotFound;
